import { render, staticRenderFns } from "./mesesNaoPagos.vue?vue&type=template&id=858b1802&"
import script from "./mesesNaoPagos.vue?vue&type=script&lang=js&"
export * from "./mesesNaoPagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports